import { appendReduxParts } from "infrastructure/store";

import ReleasesManager from "./ReleasesManager";
import { releasesManagerSaga } from "./ReleasesManager.saga";
import { releasesManager } from "./ReleasesManager.slice";

export { ReleasesManager };

appendReduxParts(
  [
    {
      reducerName: releasesManager.name,
      reducer: releasesManager.reducer
    }
  ],
  [releasesManagerSaga()]
);
